import { SignupState } from "../../../store/signup/SignupState"
import { BankAccountNumberValidator } from "./BankAccountNumberValidator"
import { BankNameValidator } from "./BankNameValidator"

export default (state: SignupState): Promise<void> => new Promise((resolve, reject) => {
    const accountNumberValidation = validateAccountNumber(state)
    const bankNameValidation = validateBankName(state)

    const validationResult = initialBankDetailsFormValidation()
    let isValid = true

    if (accountNumberValidation) {
        validationResult.accountNumberValidationMessage = accountNumberValidation
        isValid = false
    }

    if (bankNameValidation) {
        validationResult.bankNameValidationMessage = bankNameValidation
        isValid = false
    }

    if (isValid) {
        resolve()
    } else {
        reject(validationResult)
    }
})

const validateAccountNumber = (state: SignupState): string | undefined => {
    const validator = new BankAccountNumberValidator()
    return validator.validate(state.bankDetail.accountNumber, state.bankDetail.bankName)
}

const validateBankName = (state: SignupState): string | undefined => {
    const validator = new BankNameValidator()
    return validator.validate(state.bankDetail.bankName.value)
}

export interface BankDetailsFormValidation {
    accountNumberValidationMessage: string | undefined,
    bankNameValidationMessage: string | undefined,
}

const initialBankDetailsFormValidation = (): BankDetailsFormValidation => ({
    accountNumberValidationMessage: undefined,
    bankNameValidationMessage: undefined,
})
